export default __webpack_public_path__ + "static/media/discord.dbe451fb.svg";